import {InfoModuleBasicState} from '@fantasmagames/slot/src/modules/hud/info/states/InfoModuleBasicState';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {RecodeInfoModule} from '@fantasmagames/slot/src/modules/hud/info/recode/RecodeInfoModule';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';

export class RecodeInfoModuleBasicState extends InfoModuleBasicState {
	public restoreRoundWin(): void {
		const logic: RecodeLogic = this.module.logic as RecodeLogic;

		this.updateWin(logic.getTransTotalWin());
	}

	public onSpinButtonPressed(): void {
		super.onSpinButtonPressed();
		(this.module as RecodeInfoModule).spinCumulativeWins = 0;
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(FlowModuleEvents.WON_BIG_WIN, this.onWonBigWin);
	}

	protected onBigWinFinished(): void {
		const win = (this.module as RecodeInfoModule).spinCumulativeWins + this.module.logic.getNextSpinWin();

		this.updateWin(win);
	}

	protected onSpinResponse(): void {
		const logic: RecodeLogic = this.module.logic as RecodeLogic;
		if (!logic.isInFreeRounds) {
			this.module.preSpinBalanceUpdate();
			this.module.clearWin();
		}
	}

	protected onInitResponse(): void {
		if (this.module.logic.hasRestore) {
			const lastRoundWin: number = this.module.logic.getWin();
			// Should not go to negative balance.
			const newBalance = Math.max(0, this.module.logic.currentBalance - lastRoundWin);

			this.updateBalance(newBalance);
		} else {
			this.updateBalance(this.module.logic.currentBalance);
		}

		this.updateBet();
		this.updateWin(0);
	}

	protected onCanSpin(): void {
		if (!this.module.logic.hasRestore) {
			this.updateWin(this.module.lastWin);
		}

		this.updateBalance(this.module.logic.currentBalance);
	}

	protected onWonBigWin(): void {}

	protected onNoWin(): void {}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/hud/info/recode/states/RecodeInfoModuleBasicState.ts